import {
    deleteThinClientDeviceDetails,
    fetchThinClientDeviceDetails,
    setThinClientDeviceDetails
} from "../network/ThinClientOverviewNetworkAPI";

export const ThinClientOverviewReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false}
        case "LOAD_VIEW":
            fetchThinClientDeviceDetails(action.data.dispatcher)
            return state
        case "DELETE_DEVICE_DATA":
            deleteThinClientDeviceDetails(action.data.dispatcher, action.data.mac)
            return state
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "ADD_DEVICE_DATA":
            setThinClientDeviceDetails(action.data.dispatcher, action.data.stateValues, action.data.mac)
            return state
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/reducer/ThinClientOverviewReducer.js